/* Legeldle választó – csomagtermékek (v3)
   1) <legeldle-uveg-valaszto>: termékoldalon és gyorsnézetben.
      A választás natívan, form attribútummal megy a termék-űrlapba (JS nélkül is).
      Ez a réteg: kötelező-kitöltés-ellenőrzés, kiválasztott név kiírása, olvasható összegzés.
      Az űrlapot AZONOSÍTÓ alapján ismeri (data-form-id), nem keresgél az oldalon.
   2) <legeldle-valaszto-or>: biztonsági háló a szállítási adatok oldalon.
      Ha egy kosártételről hiányzik a választás, bekéri és /cart/change.js-sel elmenti. */

(function () {
  'use strict';

  function rowsComplete(root) {
    var rows = root.querySelectorAll('[data-luv-row]');
    if (!rows.length) return false;
    for (var i = 0; i < rows.length; i++) {
      if (!rows[i].querySelector('[data-luv-radio]:checked')) return false;
    }
    return true;
  }

  function markMissing(root) {
    var rows = root.querySelectorAll('[data-luv-row]');
    var first = null;
    for (var i = 0; i < rows.length; i++) {
      var ok = !!rows[i].querySelector('[data-luv-radio]:checked');
      rows[i].classList.toggle('legeldle-uv__row--hianyzik', !ok);
      if (!ok && !first) first = rows[i];
    }
    return first;
  }

  function syncPicked(row) {
    if (!row) return;
    var checked = row.querySelector('[data-luv-radio]:checked');
    var picked = row.querySelector('[data-luv-picked]');
    if (picked) picked.textContent = checked ? (checked.getAttribute('data-nev') || '') : '';
    if (checked) row.classList.remove('legeldle-uv__row--hianyzik');
  }

  function groupSummary(group) {
    var rows = group.querySelectorAll('[data-luv-row]');
    var names = [];
    for (var i = 0; i < rows.length; i++) {
      var c = rows[i].querySelector('[data-luv-radio]:checked');
      if (!c) return null;
      names.push(c.getAttribute('data-nev') || c.value);
    }
    return names.join(', ');
  }

  /* ---------- 1) termékoldali / gyorsnézeti választó ---------- */

  if (!customElements.get('legeldle-uveg-valaszto')) {

    class LegeldleUvegValaszto extends HTMLElement {

      connectedCallback() {
        if (this._kesz) return;
        this._kesz = true;

        this.formId = this.getAttribute('data-form-id');
        this.errorEl = this.querySelector('[data-luv-error]');
        this.ensureOwnForm();

        this._onSubmit = (event) => {
          var f = event.target;
          if (!f || !this.formId || f.id !== this.formId || !this.isConnected) return;
          if (!rowsComplete(this)) {
            event.preventDefault();
            event.stopPropagation();
            if (event.stopImmediatePropagation) event.stopImmediatePropagation();
            this.showError();
          }
        };
        document.addEventListener('submit', this._onSubmit, true);

        this._onChange = (event) => {
          if (event.target && event.target.matches && event.target.matches('[data-luv-radio]')) {
            syncPicked(event.target.closest('[data-luv-row]'));
            this.sync();
          }
        };
        this.addEventListener('change', this._onChange);

        var rows = this.querySelectorAll('[data-luv-row]');
        for (var i = 0; i < rows.length; i++) syncPicked(rows[i]);
        this.sync();
      }

      disconnectedCallback() {
        document.removeEventListener('submit', this._onSubmit, true);
        this.removeEventListener('change', this._onChange);
        this._kesz = false;
      }

      /* Ha ugyanaz az űrlap-azonosító kétszer van az oldalon (pl. ugyanannak a terméknek
         két gyorsnézete), a saját űrlapunkat egyedi azonosítóra állítjuk, és a saját
         mezőinket is átkötjük rá, hogy a választás biztosan a jó tételhez menjen. */
      ensureOwnForm() {
        if (!this.formId) return;
        var scope = this.closest('product-page, [data-js-product-component]');
        if (!scope) return;
        var own = scope.querySelector('form[id="' + this.formId + '"]');
        var first = document.getElementById(this.formId);
        if (own && first && own !== first) {
          var uj = this.formId + '-lv' + Math.random().toString(36).slice(2, 8);
          var kotottek = scope.querySelectorAll('[form="' + this.formId + '"]');
          for (var i = 0; i < kotottek.length; i++) kotottek[i].setAttribute('form', uj);
          own.id = uj;
          this.formId = uj;
          this.setAttribute('data-form-id', uj);
        }
      }

      sync() {
        var groups = this.querySelectorAll('[data-lv-csoport]');
        for (var i = 0; i < groups.length; i++) {
          var input = groups[i].querySelector('[data-lv-summary]');
          if (!input) continue;
          var s = groupSummary(groups[i]);
          if (s) {
            input.value = s;
            input.disabled = false;
          } else {
            input.value = '';
            input.disabled = true;
          }
        }
        if (rowsComplete(this) && this.errorEl) this.errorEl.hidden = true;
      }

      showError() {
        var first = markMissing(this);
        if (this.errorEl) this.errorEl.hidden = false;
        (first || this).scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    customElements.define('legeldle-uveg-valaszto', LegeldleUvegValaszto);
  }

  /* ---------- 2) biztonsági háló a szállítási adatok oldalon ---------- */

  if (!customElements.get('legeldle-valaszto-or')) {

    var changeUrl = (window.KROWN && KROWN.settings && KROWN.settings.routes && KROWN.settings.routes.cart_change_url
      ? KROWN.settings.routes.cart_change_url : '/cart/change') + '.js';

    function postChange(body) {
      return fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('cart/change ' + r.status);
        return r.json();
      });
    }

    class LegeldleValasztoOr extends HTMLElement {

      connectedCallback() {
        if (this._kesz) return;
        this._kesz = true;
        document.documentElement.classList.add('lvor-nyitva');

        this.errorEl = this.querySelector('[data-luv-error]');
        this.failEl = this.querySelector('[data-lvor-hiba]');
        this.saveBtn = this.querySelector('[data-lvor-mentes]');

        this.addEventListener('change', (event) => {
          if (event.target && event.target.matches && event.target.matches('[data-luv-radio]')) {
            syncPicked(event.target.closest('[data-luv-row]'));
            if (rowsComplete(this) && this.errorEl) this.errorEl.hidden = true;
          }
        });

        var rows = this.querySelectorAll('[data-luv-row]');
        for (var i = 0; i < rows.length; i++) syncPicked(rows[i]);

        if (this.saveBtn) this.saveBtn.addEventListener('click', () => this.save());

        var dels = this.querySelectorAll('[data-lvor-torles]');
        for (var d = 0; d < dels.length; d++) {
          dels[d].addEventListener('click', (event) => this.removeItem(event.currentTarget.closest('[data-lvor-tetel]')));
        }
      }

      busy(on) {
        if (!this.saveBtn) return;
        this.saveBtn.disabled = on;
        this.saveBtn.classList.toggle('working', on);
      }

      fail() {
        this.busy(false);
        if (this.failEl) this.failEl.hidden = false;
      }

      save() {
        if (!rowsComplete(this)) {
          var first = markMissing(this);
          if (this.errorEl) this.errorEl.hidden = false;
          if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (this.failEl) this.failEl.hidden = true;
        this.busy(true);

        var tetelek = Array.prototype.slice.call(this.querySelectorAll('[data-lvor-tetel]'));
        var lanc = Promise.resolve();

        tetelek.forEach(function (tetel) {
          lanc = lanc.then(function () {
            var props = {};
            try {
              var raw = tetel.querySelector('[data-lvor-props]');
              props = JSON.parse(raw ? raw.textContent : '{}') || {};
            } catch (e) { props = {}; }
            if (Array.isArray(props)) props = {};

            props._valaszto_v = tetel.getAttribute('data-verzio') || '1';
            props._valaszto_csoportok = tetel.getAttribute('data-terv') || '';
            props._valaszto_forras = 'ellenorzo';

            var groups = tetel.querySelectorAll('[data-lv-csoport]');
            for (var g = 0; g < groups.length; g++) {
              var rows = groups[g].querySelectorAll('[data-luv-row]');
              for (var r = 0; r < rows.length; r++) {
                var c = rows[r].querySelector('[data-luv-radio]:checked');
                props[rows[r].getAttribute('data-kulcs')] = c.value;
              }
              var s = groupSummary(groups[g]);
              var kulcs = groups[g].getAttribute('data-osszegzo');
              if (s && kulcs) props[kulcs] = s;
            }

            return postChange({
              id: tetel.getAttribute('data-key'),
              quantity: parseInt(tetel.getAttribute('data-qty'), 10) || 1,
              properties: props
            });
          });
        });

        lanc.then(function () { window.location.reload(); }).catch(() => this.fail());
      }

      removeItem(tetel) {
        if (!tetel) return;
        this.busy(true);
        postChange({ id: tetel.getAttribute('data-key'), quantity: 0 })
          .then(function () { window.location.reload(); })
          .catch(() => this.fail());
      }
    }

    customElements.define('legeldle-valaszto-or', LegeldleValasztoOr);
  }
})();
